import React from 'react';
import _noop from 'lodash/noop';

import { CheckmarkOutline } from '@lyearn/icons';
import { MenuItem, Scrollable } from '@lyearn/ui';
import { ListItemProps, MenuItemProps } from '@/components/SortMenu/types';

function MenuItemsMobile<T extends ListItemProps>(props: MenuItemProps<T>) {
  const { actions, onMenuClick, closeBottomSheet = _noop, className } = props;

  const onItemClick = React.useCallback(
    (id: string, item: T) => {
      closeBottomSheet();
      onMenuClick(id, item);
    },
    [onMenuClick, closeBottomSheet],
  );

  return (
    <Scrollable className={className}>
      {actions.map((item: T) => (
        <MenuItem
          key={item.id}
          className="space-s-12"
          {...item}
          StartIcon={item.Icon}
          endIcon={
            item.isSelected ? (
              <CheckmarkOutline className="h-20 w-20 flex-shrink-0" fillColorToken="icon-active" />
            ) : undefined
          }
          startIcon={item.icon}
          onClick={() => onItemClick(item.id, item)}
        />
      ))}
    </Scrollable>
  );
}

export default React.memo(MenuItemsMobile) as typeof MenuItemsMobile;
